import { useEffect } from "react"
import useRedirectPage from "./useRedirectPage"
import { useParams } from "react-router-dom"

const RedirectPageSpmo = () => {
    const {
        checkTokenSpmo
    } = useRedirectPage()
    const params = useParams()

    useEffect(() => {
        if (params.token && params.project_id &&params.calibrator_id && params.business_unit_id && params.phase) {
            checkTokenSpmo(params.token, params.project_id, params.calibrator_id, params.business_unit_id, params.phase)
        }
    }, [])

    return(
        <div className="container-fluid" style={{ height: "100vh" }}>
            <h1>Redirect Page</h1>
        </div>
    )
}

export default RedirectPageSpmo